import React from 'react';
import DataStore from '../base/plumbing/DataStore';
import PropControl from '../base/components/PropControl';
import LoginWidget, { LoginWidgetEmbed } from '../base/components/LoginWidget';
import Login from '../base/youagain';
import Wizard, {WizardStage} from '../base/components/WizardProgressWidget';

function CharitySignUpPage() {
	const path = ['widget', 'CharitySignUpPage'];
	const stagePath = ['location', 'params', 'registerStage'];
	const shareStatus = DataStore.getValue(path.concat('share'));

	return (
		<Wizard stagePath={stagePath} nonavButtons >
			<WizardStage title="Register" sufficient={Login.isLoggedIn()} complete={Login.isLoggedIn()} >
				<h3>Good-Loop: Register for a Charity account</h3>
				<LoginWidgetEmbed />
			</WizardStage>
			<WizardStage title="Claim your site">
				<h3>In the box below, enter a link to your website</h3>
				<PropControl label="Link to your website" path={path} prop="url" type="url" />
				TODO notify us on signup
				TODO Ts &amp; Cs
			</WizardStage>
			<WizardStage title="Thank you" >
				<ThankYou path={path} />
			</WizardStage>
		</Wizard>
	);
}

/** Main purpose is to provide link to pubdash page. Very important that user receives this */
function ThankYou({path}) {
	const userURL = DataStore.getValue(path.concat('url'));
	//Email support: user signed up
	return (
		<div>
			<h3>All done!</h3>
			<p>
				The Good-Loop adunit should now be installed and working correctly on your website. <br />
				To see how much your users have raised for charity, or to manage settings, <a href={`/#charitydash/${userURL}`}>visit your charity page</a>.
			</p>
			<div className="text-center"><a className="button" href={`/#charitydash/${userURL}`}>Go to your charity page</a></div>
		</div>
	);
}

export default CharitySignUpPage;
